import OtherProject from "./OtherProject";
const OtherProjects = (
) => {
    // const name1 = 'Language learning app "Cherry"';
    // const name2 = 'Enterprise logging and monitoring system';
    // const name3 = 'Analysis of stress factors among students';
    // const name4 = 'Investing stratagies comparison';

    const name1 = 'Basic RPG engine';
    // const name2 = 'Investing stratagies comparison';
    const name2 = 'Real-time talking AI Avatar';
    // const name3 = 'Language courses "Cherry"';
    const name3 = 'Language learning app "Cherry"';
    const name5 = 'Personal blog';
    // const name6 = 'Resume website';
    const name6 = 'Enterprise logginng and monitoring system';
    const name7 = 'Analysis of stress factors among students';
    const name8 = 'A single player Sea Battle game';

    
    // const name7 = 'Notes Synchronization App "NoteLink"'
    // const name8 = 'Investing stratagies comparison'
    const tags1 = 'Java, JavaFX, Maven, JUnit';
    // const tags2 = 'Tableau, Excel, Python, WIP';
    const tags2 = 'Python, TypeScript, WIP';
    const tags3 = 'DJango, Python, WIP';
    const tags4 = 'Java, SpringBoot, Hibernate';
    const tags5 = 'JS, React, Python';
    const tags6 = 'Flask, React.js, PostgreSQL';
    const tags7 = 'PowerBI, Excel, Python';
    const tags8 = 'C++, Console game';

    const github1 = 'https://gitlab.fel.cvut.cz/B222_B0B36PJV/mamaegeo/-/wikis/home';
    const github2 = 'https://github.com/mamaegeo/ISC';
    const github3 = 'https://github.com/mamaegeo/Cherry';
    const github4 = 'https://www.github.com/';
    const github5 = 'https://www.github.com/';
    // const github6 = 'https://github.com/mamaegeo/Resume';
    const github6 = 'https://github.com/B4SEE/Simplified_SIEM/';
    const github7 = 'https://github.com/mamaegeo/ZDA/blob/main/ZDA_SP.pdf'
    const github8 = 'https://github.com/mamaegeo/sea-battle'

    const web1 = "none";
    const web2 = github2;
    const web3 = github3;
    const web4 = "none";
    const web5 = github5;
    const web7 = "none";
    const web8 = "none";
    // const web6 = "https://georgemamaev.site/";
    const web6 = "https://github.com/B4SEE/Simplified_SIEM/";
    return (
        <div className="otherProjects">
            <div className="title">
                <h1>Other projects</h1>
            </div>
            <div className="project_grid">
                <div className="project_grid_column project_grid_column_l">
                <OtherProject name={name1} tags={tags1} github={github1} web={web1} />
                <OtherProject name={name3} tags={tags3} github={github3} web={web3} />
                {/* <OtherProject name={name8} tags={tags8} github={github8} web={web8} /> */}
                </div>
                <div className="project_grid_column project_grid_column_r">
                <OtherProject name={name6} tags={tags6} github={github6} web={web6} />
                <OtherProject name={name2} tags={tags2} github={github2} web={web2} />
                {/* <OtherProject name={name7} tags={tags7} github={github7} web={web2} /> */}
                </div>
            </div>
            
            
        </div>
    );
}
export default OtherProjects;